import Vue from 'vue';
import App from './app';

// eslint-disable-next-line no-new
new Vue({
  el: 'body',
  render(v) {
    return v(App, {
      props: {
        href: this.$el.attributes.href.value,
      },
    });
  },
  components: { App },
});



// WEBPACK FOOTER //
// ./src/main.js